import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";

const StaffDetailsForm = () => {
  const [formData, setFormData] = useState({
    personalDetails: {
      staffName: "",
      dob: "",
      gender: "",
      contactNumber: "",
      whatsappNumber: "",
      emailAddress: "",
      address: "",
      aadharNumber: "",
      bankDetails: {
        accountNumber: "",
        ifscCode: "",
        branch: "",
        upiId: "",
      },
    },
    educationalDetails: {
      tenth: { board: "", percentage: "" },
      twelfth: { board: "", percentage: "" },
      graduation: { board: "", percentage: "" },
      postGraduation: { board: "", percentage: "" },
    },
    professionalDetails: {
      designation: "",
      class: "",
      yearOfExperience: "",
      expertiseSubject: "",
      salary: "",
      totalLeaves: "",
      employeeType: "",
    },
  });

  const navigate = useNavigate();

  const handleChange = (e, section, subSection) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      if (subSection) {
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [subSection]: {
              ...prev[section][subSection],
              [name]: value.toUpperCase(),
            },
          },
        };
      }
      return {
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value.toUpperCase(),
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/staffs/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Staff added successfully!");
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        navigate(`/erp/staffs/list`);
      }, 2000);
    } catch (error) {
      console.error("Error adding staff:", error);
      toast.error("Failed to add staff. Please try again.");
    }
  };

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link to="/erp/staffs" className="btn btn-secondary mb-3">
              &#8592; Back to Staff List
            </Link>
            <h3 className="text-center text-success">Add New Staff</h3>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          {/* Personal Details */}
          <h4>Personal Details</h4>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Staff Name *</label>
              <input
                type="text"
                className="form-control"
                name="staffName"
                required
                value={formData.personalDetails.staffName}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Birth *</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                required
                value={formData.personalDetails.dob}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Gender *</label>
              <select
                className="form-control"
                name="gender"
                required
                value={formData.personalDetails.gender}
                onChange={(e) => handleChange(e, "personalDetails")}
              >
                <option value="">Select</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div>
          </div>

          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Contact Number *</label>
              <input
                type="number"
                className="form-control"
                name="contactNumber"
                required
                maxLength="10"
                value={formData.personalDetails.contactNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // Ensures only digits are allowed
                    handleChange(e, "personalDetails");
                  }
                }}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">WhatsApp Number *</label>
              <input
                type="text"
                className="form-control"
                name="whatsappNumber"
                maxLength="10"
                value={formData.personalDetails.whatsappNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // Ensures only digits are allowed
                    handleChange(e, "personalDetails");
                  }
                }}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Email Address *</label>
              <input
                type="email"
                className="form-control"
                name="emailAddress"
                required
                value={formData.personalDetails.emailAddress}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
          </div>

          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Aadhar Number *</label>
              <input
                type="number"
                className="form-control"
                name="aadharNumber"
                required
                maxLength="16"
                value={formData.personalDetails.aadharNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // Ensures only digits are allowed
                    handleChange(e, "personalDetails");
                  }
                }}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Address *</label>
              <input
                type="text"
                className="form-control"
                name="address"
                required
                value={formData.personalDetails.address}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
          </div>

          {/* Bank Details */}
          <h5 className="mt-4">Bank Details</h5>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Account Number</label>
              <input
                type="number"
                className="form-control"
                name="accountNumber"
                required
                value={formData.personalDetails.bankDetails.accountNumber}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">IFSC Code</label>
              <input
                type="text"
                className="form-control"
                name="ifscCode"
                required
                value={formData.personalDetails.bankDetails.ifscCode}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Branch</label>
              <input
                type="text"
                className="form-control"
                name="branch"
                required
                value={formData.personalDetails.bankDetails.branch}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
          </div>

          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">UPI ID</label>
              <input
                type="text"
                className="form-control"
                name="upiId"
                required
                value={formData.personalDetails.bankDetails.upiId}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
          </div>

          {/* Educational Details */}
          <h4 className="mt-5">Educational Details</h4>
          <div className="my-3">
            <h6>10th</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board *</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.tenth.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "tenth")
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage *</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.tenth.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "tenth")
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>12th</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board *</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.twelfth.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "twelfth")
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage *</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.twelfth.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "twelfth")
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>Graduation</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board </label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.graduation.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "graduation")
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage </label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.graduation.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "graduation")
                  }
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>Post Graduation</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board </label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.postGraduation.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "postGraduation")
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage </label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.postGraduation.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "postGraduation")
                  }
                />
              </div>
            </div>
          </div>

          {/* Professional Details */}
          <h4 className="mt-5">Professional Details</h4>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Designation *</label>
              <input
                type="text"
                className="form-control"
                name="designation"
                required
                value={formData.professionalDetails.designation}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Class Taken *</label>
              <input
                type="text"
                className="form-control"
                name="class"
                required
                value={formData.professionalDetails.class}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Years of Experience *</label>
              <input
                type="number"
                className="form-control"
                name="yearOfExperience"
                required
                value={formData.professionalDetails.yearOfExperience}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
          </div>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Expertise Subject *</label>
              <input
                type="text"
                className="form-control"
                name="expertiseSubject"
                required
                value={formData.professionalDetails.expertiseSubject}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Salary (in Rupees) *</label>
              <input
                type="number"
                className="form-control"
                name="salary"
                required
                value={formData.professionalDetails.salary}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Employee Type *</label>
              <select
                className="form-control"
                name="employeeType"
                required
                value={formData.professionalDetails.employeeType}
                onChange={(e) => handleChange(e, "professionalDetails")}
              >
                <option value="">Select</option>
                <option value="TEACHING">Teaching</option>
                <option value="NON-TEACHING">Non-Teaching</option>
                <option value="ADMINISTRATIVE">Administrative</option>
              </select>
            </div>
          </div>

          <div className="d-grid gap-2 d-flex justify-content-center mt-4">
            <button type="submit" className="btn btn-success">
              Add Staff
            </button>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default StaffDetailsForm;
